import { atom } from 'recoil'

/**
 * The comment whose conversation drawer is open, or null. One atom so only
 * one drawer exists per page and any card can open it.
 */
export const openConversationContentIdState = atom<number | null>({
    key: 'openConversationContentIdState',
    default: null
})
